import { useState } from 'react';

/**
 * Holds the count of new topics that arrived while the user was scrolled down.
 * Scroll state and scroll-to-top are owned by ScrollableWithBackToTop; this hook is only for the "N temas nuevos" chip.
 */
export function useLiveTopicsScrollLock() {
  const [newTopicsCount, setNewTopicsCount] = useState(0);
  return { newTopicsCount, setNewTopicsCount };
}
